var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.16324 6.54492V9.64317H12.5563C12.3634 10.6396 11.7845 11.4832 10.9163 12.0505L13.5655 14.0651C15.109 12.6688 15.9995 10.6178 15.9995 8.1814C15.9995 7.61412 15.9476 7.06861 15.8511 6.54501L8.16324 6.54492Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.58869 9.52295L2.9912 9.97121L0.876251 11.5858C2.2194 14.1967 4.97229 16.0004 8.16318 16.0004C10.3671 16.0004 12.2148 15.2877 13.5654 14.0658L10.9162 12.0512C10.189 12.5312 9.2614 12.8222 8.16318 12.8222C6.04086 12.8222 4.23768 11.4185 3.59203 9.52757L3.58869 9.52295Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.876132 4.41553C0.319608 5.49187 0.000549316 6.70645 0.000549316 8.001C0.000549316 9.29555 0.319608 10.5101 0.876132 11.5865C0.876132 11.5937 3.59217 9.52099 3.59217 9.52099C3.42891 9.04098 3.33242 8.53191 3.33242 8.00092C3.33242 7.46993 3.42891 6.96086 3.59217 6.48086L0.876132 4.41553Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.16335 3.18552C9.36552 3.18552 10.4341 3.59279 11.2875 4.37827L13.625 2.08734C12.2076 0.792793 10.3673 0 8.16335 0C4.97246 0 2.2194 1.7964 0.876251 4.41464L3.5922 6.48014C4.23777 4.58917 6.04103 3.18552 8.16335 3.18552Z",
    fill: "#EA4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.f5f52dbcfc5f27676e4f86bd8cad7978.svg";
export { ForwardRef as ReactComponent };